import { Button, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { L } from 'harmony-language';
import React from 'react';
import type { Medication } from '../../../types';
import { ColorSelector } from '../../shared/inputs/color-selector';
import { EntityColors } from '../../../styles/agistics-colors';

interface EditCreateMedicationProps {
    existingMedication: Medication;
    addMedication: (data: Medication) => Promise<void>;
    editMedication: (data: Medication) => Promise<void>;
    closeModal: () => void;
}

export const EditCreateMedication = (props: EditCreateMedicationProps) => {
    const { existingMedication, addMedication, editMedication, closeModal } = props;

    const [medication, setMedication] = React.useState<Medication>(existingMedication || {
        name: '',
        hexColor: '',
        requiresFlush: false,
    });

    async function submitForm(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        e.stopPropagation();

        if (medication.id) {
            await editMedication(medication);
        } else {
            await addMedication(medication);
        }

        closeModal();
    }

    return (
        <div style={{ minWidth: '20vw' }}>
            <form id='edit-create-medication-form' name='edit-create-medication-form' onSubmit={submitForm}>
                <div style ={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'flex-end' }}>
                    <TextField
                        label={L.name()}
                        variant='standard'
                        value={medication.name}
                        onChange={(e) => setMedication(locationGroup => ({ ...locationGroup, name: e.target.value }))}
                        fullWidth
                        required
                    />
                    <ColorSelector
                        value={medication.hexColor}
                        onChange={(color) => setMedication(locationGroup => ({ ...locationGroup, hexColor: color }))}
                        colors={Object.values(EntityColors)}
                    />
                </div>
                <FormControlLabel
                    label={L.requiresFlush()}
                    control={
                        <Checkbox
                            checked={medication.requiresFlush}
                            onChange={() => setMedication(medication => ({ ...medication, requiresFlush: !medication.requiresFlush }))}
                        />
                    }
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        type='submit'
                        title={L.save()}
                        variant='contained'
                        color='primary'
                    >
                        {existingMedication ? L.updateMedication() : L.createMedication()}
                    </Button>
                </div>
            </form>
        </div>
    );
};